import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getCandidateCountApi } from "../../API/API";

function* getCandidateCountSaga(params) {
    try {
        const response = yield call(getCandidateCountApi, params);
        yield put({
            type: types.GET_CANDIDATES_COUNTS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: types.GET_CANDIDATES_COUNTS_FAILURE, error });
    }
}

export function* watchGetCandidateCountSaga() {
    yield takeEvery(types.GET_CANDIDATES_COUNTS_REQUESTED, getCandidateCountSaga);
}